import React from 'react';
export var Necessity = {
  OPTIONAL: 'optional',
  REQUIRED: 'required'
};
export var NecessityStyle = {
  FULL: 'full',
  ABBREVIATED: 'abbreviated'
};
export var NecessityIndicator = function NecessityIndicator(_ref) {
  var required = _ref.required,
      necessityStyle = _ref.necessityStyle,
      displayedNecessity = _ref.displayedNecessity,
      className = _ref.className;
  var necessityText = '';

  if (required && displayedNecessity === 'required') {
    necessityText = "(".concat(necessityStyle === 'abbreviated' ? 'Req' : 'Required', ")");
  } else if (!required && displayedNecessity === 'optional') {
    necessityText = "(".concat(necessityStyle === 'abbreviated' ? 'Opt' : 'Optional', ")");
  }

  if (necessityText) {
    return /*#__PURE__*/React.createElement("span", {
      className: className
    }, necessityText);
  }

  return null;
};
export default NecessityIndicator;
//# sourceMappingURL=NecessityIndicator.js.map